const BACKEND_URL = process.env.REACT_APP_API_URL || "Please specify backend URL in .env file";
const RECAPTCHA_SITE_KEY =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || "Please specify Recaptcha site key in .env file";

export { BACKEND_URL, RECAPTCHA_SITE_KEY };
